'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var bemReactClassname = require('bem-react-classname');
var modal = require('@alfalab/core-components/modal');
var cn = require('../../cn.js');
var core_genericConfirmationModal_confirmation_smsSignConfirmation = require('./confirmation/sms-sign-confirmation.js');
var core_genericConfirmationModal_error_smsSignError = require('./error/sms-sign-error.js');
var core_genericConfirmationModal_phoneHint_smsSignPhoneHint = require('./phone-hint/sms-sign-phone-hint.js');
var core_genericConfirmationModal_iosVersion = require('./ios-version.js');
require('./generic-confirmation-modal.css');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

var SMALL_WIDTH = 768;
var renderPrettyModal = function (smallScreen) {
    if (!smallScreen) {
        return null;
    }
    var versionIOS = core_genericConfirmationModal_iosVersion()[0];
    var appSelectorExists = !!document.querySelectorAll('*[class*="-app"]').length
        || !!document.querySelectorAll('*[id*="-app"]').length;
    // works for ios higher 12
    return appSelectorExists ? (React__default.default.createElement("style", null, "\n                *[class*=\"-app\"], *[id*=\"-app\"] { display: none !important; }\n                ".concat(versionIOS >= 12 ? '.modal__wrapper { position: relative }' : '', "\n                "))) : null;
};
/**
 * Компонент модального окна подписания.
*/
var GenericConfirmationModal = /** @class */ (function (_super) {
    tslib.__extends(GenericConfirmationModal, _super);
    function GenericConfirmationModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cn = bemReactClassname.createCn('core-generic-confirmation-modal');
        _this.state = {
            isShowingHint: false,
            isCountdownFinished: false,
            retries: 0,
        };
        _this.setInputRef = function (input) {
            _this.inputRef = input;
        };
        _this.setsmsCountdownRef = function (smsCountdown) {
            _this.smsCountdownRef = smsCountdown;
        };
        _this.handleClose = function () {
            var onClose = _this.props.onClose;
            _this.setState({ retries: 0 });
            onClose();
        };
        _this.handleInputFinished = function (value) {
            var onInputFinished = _this.props.onInputFinished;
            onInputFinished(value);
        };
        _this.handleInputChange = function (value) {
            var onInputChange = _this.props.onInputChange;
            if (onInputChange) {
                onInputChange(value);
            }
        };
        _this.handleSmsRetryClick = function () {
            var onSmsRetryClick = _this.props.onSmsRetryClick;
            _this.setState(function (prevState) { return ({
                retries: prevState.retries + 1,
                isCountdownFinished: false,
            }); });
            onSmsRetryClick();
        };
        _this.handleSmsRetryFromHintClick = function () {
            var onSmsRetryClick = _this.props.onSmsRetryClick;
            _this.setState(function (prevState) { return ({
                retries: prevState.retries + 1,
                isShowingHint: false,
                isCountdownFinished: false,
            }); });
            onSmsRetryClick();
        };
        _this.handleCountdownFinished = function () {
            var onCountdownFinished = _this.props.onCountdownFinished;
            _this.setState({ isCountdownFinished: true });
            if (onCountdownFinished) {
                onCountdownFinished();
            }
        };
        _this.handleSmsHintLinkClick = function () {
            var onSmsHintLinkClick = _this.props.onSmsHintLinkClick;
            _this.setState({ isShowingHint: true });
            if (onSmsHintLinkClick) {
                onSmsHintLinkClick();
            }
        };
        _this.handleErrorSmsRetryClick = function () {
            var _a = _this.props, onActionWithFatalError = _a.onActionWithFatalError, onSmsRetryClick = _a.onSmsRetryClick;
            if (onActionWithFatalError) {
                onActionWithFatalError();
            }
            else {
                onSmsRetryClick();
            }
        };
        _this.handleModalMount = function () {
            var isProcessing = _this.props.isProcessing;
            if (!isProcessing) {
                _this.focus();
            }
        };
        return _this;
    }
    GenericConfirmationModal.prototype.componentDidMount = function () {
        var versionIOS = core_genericConfirmationModal_iosVersion()[0];
        // works for android and ios lower 12
        if (versionIOS < 12) {
            setTimeout(function () {
                // lose focus to modal can appears
                var inputs = document.querySelectorAll(':focus');
                if (inputs && inputs.forEach) {
                    inputs.forEach(function (el) { return el.blur(); });
                }
            }, 0);
        }
    };
    GenericConfirmationModal.prototype.render = function () {
        var _a = this.props, isVisible = _a.isVisible, hasCloser = _a.hasCloser, fullScreen = _a.fullScreen, wrapperClassName = _a.wrapperClassName, signTitle = _a.signTitle, isProcessing = _a.isProcessing, additionalContent = _a.additionalContent, requiredCharAmount = _a.requiredCharAmount, hasSmsCountdown = _a.hasSmsCountdown, countdownDuration = _a.countdownDuration, phone = _a.phone, value = _a.value, hasPhoneMask = _a.hasPhoneMask, error = _a.error, errorTitle = _a.errorTitle, initiallyDisplayCountdown = _a.initiallyDisplayCountdown, zIndex = _a.zIndex, dataTestId = _a["data-test-id"];
        var isSmallWidth = typeof window !== 'undefined' && window.innerWidth <= SMALL_WIDTH;
        return (React__default.default.createElement(modal.Modal, { open: isVisible, size: "s", hasCloser: hasCloser, fullscreen: fullScreen, wrapperClassName: wrapperClassName, zIndex: zIndex, className: this.cn(), onClose: this.handleClose, onMount: this.handleModalMount, dataTestId: dataTestId },
            React__default.default.createElement(modal.Modal.Header, { className: this.cn('header'), hasCloser: true }),
            this.shouldShowSignComponent && (React__default.default.createElement(core_genericConfirmationModal_confirmation_smsSignConfirmation, { isProcessing: isProcessing, isSmsHintVisible: this.shouldShowHintLink, additionalContent: additionalContent, requiredCharAmount: requiredCharAmount, hasSmsCountdown: hasSmsCountdown, countdownDuration: countdownDuration, initiallyDisplayCountdown: initiallyDisplayCountdown, phone: phone, value: value, hasPhoneMask: hasPhoneMask, error: this.nonFatalError, title: signTitle, inputRef: this.setInputRef, smsCountdownRef: this.setsmsCountdownRef, onInputFinished: this.handleInputFinished, onInputChange: this.handleInputChange, onSmsRetryClick: this.handleSmsRetryClick, onCountdownFinished: this.handleCountdownFinished, onSmsHintLinkClick: this.handleSmsHintLinkClick })),
            this.shouldShowErrorComponent && (React__default.default.createElement(core_genericConfirmationModal_error_smsSignError, { title: errorTitle, error: error, onRetryClick: this.handleErrorSmsRetryClick })),
            this.shouldShowHintComponent && (React__default.default.createElement(core_genericConfirmationModal_phoneHint_smsSignPhoneHint, { onSmsRetryClick: this.handleSmsRetryFromHintClick })),
            isVisible && (renderPrettyModal(isSmallWidth))));
    };
    Object.defineProperty(GenericConfirmationModal.prototype, "shouldShowSignComponent", {
        get: function () {
            var isShowingHint = this.state.isShowingHint;
            return !this.shouldShowErrorComponent && !isShowingHint;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericConfirmationModal.prototype, "shouldShowHintComponent", {
        get: function () {
            var isShowingHint = this.state.isShowingHint;
            return !this.shouldShowErrorComponent && isShowingHint;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericConfirmationModal.prototype, "shouldShowErrorComponent", {
        get: function () {
            var _a = this.props, errorIsFatal = _a.errorIsFatal, error = _a.error;
            return errorIsFatal && !!error;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericConfirmationModal.prototype, "nonFatalError", {
        get: function () {
            var _a = this.props, errorIsFatal = _a.errorIsFatal, error = _a.error;
            return errorIsFatal ? null : error;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GenericConfirmationModal.prototype, "shouldShowHintLink", {
        get: function () {
            var _a = this.state, isCountdownFinished = _a.isCountdownFinished, retries = _a.retries;
            var isProcessing = this.props.isProcessing;
            return isCountdownFinished && !isProcessing && retries > 0;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Устанавливает фокус на элемент инпута.
     */
    GenericConfirmationModal.prototype.focus = function () {
        if (this.inputRef) {
            this.inputRef.focus();
        }
    };
    /**
     * Сбрасывает таймер
     */
    // eslint-disable-next-line
    GenericConfirmationModal.prototype.resetCountdown = function () {
        if (this.smsCountdownRef) {
            this.smsCountdownRef.startSmsCountdown();
        }
    };
    GenericConfirmationModal.defaultProps = {
        hasCloser: true,
        hasPhoneMask: true,
        hasSmsCountdown: true,
        initiallyDisplayCountdown: true,
    };
    return GenericConfirmationModal;
}(React.Component));
/**
 * @visibleName GenericConfirmationModal
 */
// eslint-disable-next-line
// @ts-ignore
var genericConfirmationModal = cn.withTheme(GenericConfirmationModal);

exports.GenericConfirmationModal = GenericConfirmationModal;
exports.default = genericConfirmationModal;
